import {Component, Input, OnInit} from '@angular/core';
import {IoTDeviceConfigurationParse2} from "../../ParseClass/IoTDeviceConfiguration.Parse";

@Component({
    selector: 'app-box-iot-devices-configuration',
    templateUrl: './box-iot-devices-configuration.component.html',
    styleUrls: ['./box-iot-devices-configuration.component.scss'],
    standalone: false
})
export class BoxIotDevicesConfigurationComponent implements OnInit {
    @Input() iotDeviceConfiuration: IoTDeviceConfigurationParse2 | undefined
    @Input() disabled: boolean = false;

    constructor() {
    }

    ngOnInit(): void {
    }
    getValue(device: IoTDeviceConfigurationParse2, label: keyof IoTDeviceConfigurationParse2) {
        const value = device[label];
        return value
        // const ND = this.translateService.instant('NaN');
        //   return ND;
    }
}
